module.exports = __webpack_public_path__ + "img/z09.61752d42.jpg";